const undefined = void 0;

const window = noop.constructor.call(null, 'return this')();
const {
    $, _, kendo, document, console,
    JSON, setTimeout, WebSocket, alert, location, history,
    decodeURIComponent, encodeURIComponent, decodeURI,
    Object, Array, Date, Math,
    isFinite, isNaN, open,
} = window;
const { parse, stringify } = JSON;
const { pow } = Math;
const { create, keys } = Object;
const { UTC } = Date;
const {
    forEach, debounce, map, mapValues, identity, keyBy, sortBy, some,
    forEachRight, times, throttle,
} = _;

function noop () {
    // void
}
function new_object () {
    return create(null);
}


function empty_object (obj) {
    if (obj != null) {
        keys(obj).forEach(key => {
            delete obj[key];
        });
    }
}


const CHANGE_EVENTS = 'change keyup blur paste cut mouseup';

const MONTHS = [
    'Jan.', 'Feb.', 'März', 'Apr.', 'Mai',  'Juni',
    'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez',
];

const DAYS = [
    'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So',
];
const sasl_digest_md5 = (function () {
    'use strict';

/**
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

    const md5 = (function () {
        function rstr_md5(s) {
            return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
        }

        function rstr2binl(input) {
            var output = Array(input.length >> 2);
            for (var i = 0; i < output.length; i++) {
                output[i] = 0;
            }
            for (var i = 0; i < input.length * 8; i += 8) {
                output[i>>5] |= (input.charCodeAt(i / 8) & 0xFF) << (i%32);
            }
            return output;
        }

        function binl2rstr(input) {
            var output = "";
            for(var i = 0; i < input.length * 32; i += 8) {
                output += String.fromCharCode((input[i>>5] >>> (i % 32)) & 0xFF);
            }
            return output;
        }

        function rstr2hex(input) {
            var hex_tab = "0123456789abcdef";
            var output = "";
            var x;
            for (var i = 0; i < input.length; i++) {
                x = input.charCodeAt(i);
                output += hex_tab.charAt((x >>> 4) & 0x0F) +
                    hex_tab.charAt(x & 0x0F);
            }
            return output;
        }

        function rstr_md5(s) {
            return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
        }

        function binl_md5(x, len) {
            /* append padding */
            x[len >> 5] |= 0x80 << ((len) % 32);
            x[(((len + 64) >>> 9) << 4) + 14] = len;

            var a = 1732584193;
            var b = -271733879;
            var c = -1732584194;
            var d = 271733878;

            for (var i = 0; i < x.length; i += 16) {
                var olda = a;
                var oldb = b;
                var oldc = c;
                var oldd = d;

                a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
                d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
                c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
                b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
                a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
                d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
                c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
                b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
                a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
                d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
                c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
                b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
                a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
                d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
                c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
                b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

                a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
                d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
                c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
                b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
                a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
                d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
                c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
                b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
                a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
                d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
                c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
                b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
                a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
                d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
                c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
                b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

                a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
                d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
                c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
                b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
                a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
                d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
                c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
                b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
                a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
                d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
                c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
                b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
                a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
                d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
                c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
                b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

                a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
                d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
                c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
                b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
                a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
                d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
                c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
                b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
                a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
                d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
                c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
                b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
                a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
                d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
                c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
                b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

                a = safe_add(a, olda);
                b = safe_add(b, oldb);
                c = safe_add(c, oldc);
                d = safe_add(d, oldd);
            }
            return [a, b, c, d];
        }

        function md5_cmn(q, a, b, x, s, t) {
            return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
        }

        function md5_ff(a, b, c, d, x, s, t) {
            return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
        }

        function md5_gg(a, b, c, d, x, s, t) {
            return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
        }

        function md5_hh(a, b, c, d, x, s, t) {
            return md5_cmn(b ^ c ^ d, a, b, x, s, t);
        }

        function md5_ii(a, b, c, d, x, s, t) {
            return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
        }

        function safe_add(x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF);
            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return (msw << 16) | (lsw & 0xFFFF);
        }

        function bit_rol(num, cnt) {
            return (num << cnt) | (num >>> (32 - cnt));
        }

        return function (data, binary) {
            const digest = rstr_md5(data);
            return binary ? digest : rstr2hex(digest);
        };
    })();

/**
 * (The MIT License)
 * 
 * Copyright (c) 2012-2013 Jared Hanson
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

    function genNonce () {
        const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
        const result = Array(24);
        try {
            const rand = new window.Int8Array(24);
            window.crypto.getRandomValues(rand);
            for (let i = 0; i < 24; ++i) {
                result[i] = CHARS[rand[i] & 63];
            }
        } catch (e) {
            for (let i = 0; i < 24; ++i) {
                result[i] = CHARS[(Math.random() * 64) | 0];
            }
        }
        return result.join('');
    }

    function join() {
        return [].join.call(arguments, ':');
    }

    function sasl_digest_md5 (msg, username, password) {
        const { nonce, left_cnonce } = msg;

        const uri = 'ldap/windc2.fu-berlin.de';
        const realm = 'fu-berlin.de';
        const nc = '00000001';
        const qop = 'auth';

        const right_cnonce = genNonce();
        const cnonce = left_cnonce + right_cnonce;
        const ha1 = md5(join(md5(join(username, realm, password), true), nonce, cnonce));
        const ha2 = md5(join('AUTHENTICATE', uri));
        const digest = md5(join(ha1, nonce, nc, cnonce, qop, ha2));

        const result = { username, digest, right_cnonce };
        return result;
    };

    return sasl_digest_md5;
})();
function date_to_es_value (string) {
    let match = /^\s*(?:(?:(\d{1,2})[.])?(\d{1,2})[.])?(\d{4})(?:[,. um]*(\d{1,2})(?::(\d{1,2})(?::(\d{1,2}))?)?)?\s*$/.exec(string);
    if (!match) {
        // TODO: US Format
        return;
    }

    let [_m, dd, mm, yy, hh, ii, ss] = match;

    let elements = 0;
    (
           yy && ++elements
        && mm && ++elements
        && dd && ++elements
        && hh && ++elements
        && ii && ++elements
        && ss && ++elements
    );

    if (!elements) {  // impossible
        return;
    }

    let start = date_to_array(new Date(
        (elements >= 1) ? +yy     : 2018,
        (elements >= 2) ? +mm - 1 : 0,
        (elements >= 3) ? +dd     : 1,
        (elements >= 4) ? +hh     : 0,
        (elements >= 5) ? +ii     : 0,
        (elements >= 6) ? +ss     : 0,
    ));

    let end = start.slice();
    ++end[elements - 1];
    end = norm_array_date(end);

    start = array_to_ymdhis(start);
    end = array_to_ymdhis(end);
    return `(>=${start} AND <${end})`;
}


function date_to_array (date) {
    if (date && isFinite(+date)) {
        return [
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
        ];
    }
}


function date_to_utcarray (date) {
    if (date && isFinite(+date)) {
        return [
            date.getUTCFullYear(),
            date.getUTCMonth() + 1,
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds(),
        ];
    }
}


function array_to_date (array) {
    if (array) {
        let [yy, mm, dd, hh, ii, ss] = array;
        return new Date(yy, mm - 1, dd, hh, ii, ss);
    }
}


function array_to_utcdate (array) {
    if (array) {
        let [yy, mm, dd, hh, ii, ss] = array;
        return new Date(UTC(yy, mm - 1, dd, hh, ii, ss));
    }
}


function array_to_ymdhis (array) {
    if (array) {
        const [yy, mm, dd, hh, ii, ss] = array;
        return [
            prefixed_number(yy, 4),
            prefixed_number(mm, 2),
            prefixed_number(dd, 2),
            prefixed_number(hh, 2),
            prefixed_number(ii, 2),
            prefixed_number(ss, 2),
        ].join('');
    }
}


function norm_array_date (data) {
    data = array_to_date(data);
    data = date_to_array(data);
    return data;
}


function date_from_utcdate (data) {
    data = date_to_utcarray(data);
    data = array_to_date(data);
    return data;
}


function date_to_utcdate (data) {
    data = date_to_array(data);
    data = array_to_utcdate(data);
    return data;
}


function date_to_isostring (data) {
    data = date_to_utcdate(data);
    if (data && isFinite(+data)) {
        return data.toISOString();
    }
}


function parse_time (date) {
    if (date) {
        if (!(date instanceof Date)) {
            if (!/Z$/.exec(date)) {
                date += 'Z';
            }
            date = new Date(date);
            date = date_from_utcdate(date);
            return date;
        } else if (isFinite(+date)) {
            return date;
        }
    }
}
function make_function_with_depencies (default_immediate) {
    let counter = 0;
    let waiting = [];

    function execute (waiting) {
        forEach(waiting, fta => {
            setTimeout(function ([func, self, args]) {
                func.apply(self, args);
            }, 0, fta);
        });
    }

    function got_dependency (func) {
        let decr = 1;
        ++counter;

        return function () {
            if (decr) {
                decr = 0;

                --counter;
                if (counter <= 0) {
                    setTimeout(execute, 0, waiting);
                    waiting = null;
                }
            }

            return func.apply(this, arguments);
        };
    }

    function needs_dependency (func, immediate) {
        function defer () {
            if (counter <= 0) {
                func.apply(this, arguments);
            } else {
                waiting.push([
                    func,
                    this,
                    [].slice.call(arguments),
                ]);
            }
        }

        if (immediate == null ? default_immediate : immediate) {
            setTimeout(defer, 0);
        } else {
            return defer;
        }
    }

    return [got_dependency, needs_dependency];
}
function make_box (color, data, append, movable) {
    const css = {
        background: '#f8f8f8',
        boxShadow: '0 0 0.15rem #000',
        border: '0.2rem solid',
        borderColor: color || '#ffffff',
    };
    if (movable) {
        css.borderTopWidth = '1.5rem';
        css.cursor = 'move';
    }
    return $('<div>', {
        data,
        css: {
            verticalAlign: 'top',
            display: 'inline-block',
            padding: '0.5rem',
        },
        append: $('<div/>', {
            class: 'outer',
            css,
            append: $('<div/>', {
                class: 'inner',
                css: { cursor: 'auto' },
                append,
            }),
        }),
    });
}


function inline_wrap (inner) {
    return $('<div>', {
        css: { display: 'inline-block' },
        append: $('<div>', {
            css: { display: 'block' },
            append: inner,
        }),
    });
}
function make_color_picker_btn (color, sendfn) {
    const color_picker_btn = $('<div>', {
        css: {
            float: 'left',
            padding: '0.3ex 0',
        },
    });
    $('<div>', {
        appendTo: color_picker_btn,
    }).kendoColorPicker({
        value: color || '#ffffff',
        buttons: false,
        select: debounce(({value}) => { sendfn(value) }, 240),
    });
    return color_picker_btn;
}
function make_colorfn (notification, collection, what, key) {
    return (msg) => {
        const { id, count, [key || 'color']: value } = msg;
        const element = collection[id];
        if (element) {
            const { name_input } = element.data();
            if (count) {
                $('>.outer', element).css({ borderColor: value });
            } else {
                notification.warning(`${ what } nicht eingefärbt: „${ name_input.val() }“.`);
            }
        }
    };
}
function make_delete_btn (delete_what, name_input, sendfn) {
    return $('<button/>', {
        type: 'button',
        class: 'k-button',
        text: '×',
        css: {
            float: 'right',
            color: 'crimson',
            padding: '0.3ex 1ex',
            marginTop: '2px',
        },
        title: `${delete_what} löschen. (Weitere Nachfrage erfolgt.)`,
        on: {
            click (ev) {
                ev.preventDefault();
                kendo.confirm($('<span/>', { append: [
                    `Wollen Sie ${delete_what} „`,
                    $('<tt>', { text: name_input.val() }),
                    '“ wirklich löschen?',
                    $('<br/>'),
                    'Das Löschen kann nicht wieder rückgängig gemacht werden!'
                ] })).then(sendfn);
            },
        },
    });
}
function make_div_cell (append, proto) {
    return $(proto || '<div>', {
        append,
        css: {
            width: '100%',
            maxWidth: '100%',
            display: 'block',
            padding: '0.25rem',
        },
    });
}


function make_label_cell (append, proto) {
    return make_div_cell(append, proto || '<label>');
}


function make_h2_cell (text) {
    return make_div_cell($('<h2>', {
        text,
        css: {
            textAlign: 'center',
            margin: '0.15rem 0 0 0',
        },
    }));
}


function make_bottom_cell (append, proto) {
    return $(proto || '<div>', {
        append,
        css: {
            textAlign: 'center',
            padding: '0.3rem',
        },
    });
}


function make_static_nameinput (name) {
    return {
        val () {
            return name;
        },
    };
}


function make_default_bottom (name_input, send, id, color, prefix, text) {
    const color_input = make_color_picker_btn(color, make_sendfn(send, id, prefix + 'color', 'color'));
    return make_bottom_cell([
        color_input,
        make_delete_btn(text, name_input, make_sendfn(send, id, prefix + 'remove')),
    ]);
}
function make_list_fn (get) {
    function cb (data) {
        get({ data });
    }
    return msg => {
        const { data } = msg;
        sort_by_rank(data);
        forEach(data, cb);
    };
}
function make_name_input (name, sendfn) {
    const name_input = $('<input/>', {
        type: 'text',
        class: 'k-input',
        val: name,
        css: {
            width: '100%',
            maxWidth: '100%',
            margin: 0,
        },
    }).on(CHANGE_EVENTS, debounce(ev => {
        const new_name = name_input.val();
        if (new_name && (new_name !== name)) {
            name = new_name;
            sendfn(name);
        }
    }, 360));
    return name_input;
}
function make_sendfn (send, id, type, key) {
    return (value) => {
        const msg = { type, id };
        if (key) {
            msg[key] = value;
        }
        send(msg);
    };
}
function make_timestamp_input (appendTo, append, onchange, type) {
    return $('<input>', {
        placeholder: 'dd.mm.yyyy hh:ii:ss',
        appendTo: $(type || '<label>', {
            append,
            appendTo: $('<p>', { appendTo, }),
        }),
        on: (onchange ? {
            change () {
                const self = $(this);
                const dt = self.getKendoDateTimePicker();
                let value = date_to_isostring(self.val() && dt.value());
                onchange(value, self, dt);
            },
        } : {}),
    }).kendoDateTimePicker({
        format: 'dd.MM.yyyy HH:mm:ss',
        culture: 'de-DE',
    }).getKendoDateTimePicker();
}
function make_value_textarea (val, sendfn) {
    const value_textarea = $('<textarea>', {
        val,
        class: 'k-textarea',
        css: { width: '15rem', },
    }).on(CHANGE_EVENTS, debounce(ev => {
        const new_val = value_textarea.val();
        if (val !== new_val) {
            val = new_val;
            sendfn(val);
        }
    }, 360));
    return value_textarea;
}
function make_ws (url, open, functions) {
    const ws = new WebSocket(url);
    const [is_ready, when_ready] = make_function_with_depencies(true);

    open = is_ready(open || noop);
    $(ws).on({
        message (ev) {
            const msg = parse(ev.originalEvent.data);
            console.log('<', msg);
            const { type } = msg;
            (functions[type] || noop)(msg);
        },

        open,

        error (ev) {
            alert('Error.');
        },
    });

    return msg => {
        when_ready(function () {
            if (ws.readyState === 1) {
                console.log('>', msg);
                ws.send(stringify(msg));
            } else {
                console.log('Dropped message', msg);
            }
        });
    };
}
function enable_notifications (container) {
    if (notification == null) {
        notification = $('<div>', {
            appendTo: $('<div>', {
                appendTo: (container || document.body),
            }),
        }).kendoNotification({
            allowHideAfter: 1000,
        }).data('kendoNotification');
    }
    return notification;
}


let notification = undefined;
function linear_to_name (lin) {
    if (lin === +lin) {
        switch (lin) {
            case -2: return $('<strong>', { text: 'vorgestern' });
            case -1: return $('<strong>', { text: 'gestern' });
            case  0: return $('<strong>', { text: 'heute' });
            case +1: return $('<strong>', { text: 'morgen' });
            case +2: return $('<strong>', { text: 'übermorgen' });
            default: {
                if (lin < 0) {
                    return $('<span>', { append: [
                        document.createTextNode('vor '),
                        $('<strong>', { text: -lin }),
                        document.createTextNode(' Tagen'),
                    ] });
                } else {
                    return $('<span>', { append: [
                        document.createTextNode('in '),
                        $('<strong>', { text: lin }),
                        document.createTextNode(' Tagen'),
                    ] });
                }
            }
        }
    }
}
function prefixed_number (n, d) {
    const add = pow(10, d);
    n |= 0;
    if (n >= add) {
        return String(n);
    } else {
        return String(n + add).substr(1);
    }
}
function sort_by_rank (data) {
    if (data) {
        data.sort(function (a, b) {
            a = a.rank || -1;
            b = b.rank || -1;
            return a > b ? +1 : (a < b ? -1 : 0);
        });
    }
    return data;
}


function sort_by_string (data, key) {
    if (data) {
        if (!key) {
            key = identity;
        }
        data.sort(function (a, b) {
            return key(a).localeCompare(key(b), 'de-DE-u-co-phonebk-kf-lower', {
                ignorePunctuation: true,
                numeric: true,
                sensitivity: 'variant',
            });
        });
    }
    return data;
}


function sort_by_name (data) {
    return sort_by_string(data, ({ name }) => name);
}
function make_sortable_ranking (container, change, options) {
    if (!change) {
        change = noop;
    }

    return container.kendoSortable({
        container,
        change,
        handler: '.outer',
        ignore: '.inner *',
        filter: '>*',
        autoScroll: true,
        hint (elem) {
            const append = elem.clone();
            $('>.outer>.inner>:not(:first)', append).remove();
            return $('<div>', {
                class: 'umlaufverwaltung-content',
                append,
            });
        },
        end (ev) {
            const { item } = ev;
            item.css('display', 'inline-block');
        },
    }).getKendoSortable();
}
function new_textbox (data, prefix, send) {
    const { id, name, color, value } = data;

    const name_input = make_name_input(name, make_sendfn(send, id, prefix + 'name', 'name'));
    const value_textarea = make_value_textarea(value, make_sendfn(send, id, prefix + 'value', 'value'));

    return make_box(color, { name_input, value_textarea, id }, [
        make_div_cell(make_div_cell(name_input)),
        make_label_cell(value_textarea),
        make_default_bottom(name_input, send, id, color, prefix, 'den Textblock'),
    ], 'movable');
}
function ablage_list_common (insert) {
    const form = $('#form');
    const { url } = form.data();

    $(form).on('keypress', 'input[type=text]', ev => {
        const { keyCode, which } = ev;
        const key = (keyCode || which);
        if (key === 10 || key === 13) {
            ev.preventDefault();
        }
    });

    enable_notifications(form);

    const select_tags_container = $('<p>');

    const [got_dependency, needs_dependency] = make_function_with_depencies();

    let ignore_hashchange = 0;
    let current_callid = 0;

    const select_checkboxlist = $('<select>', {
        attr: { 'data-placeholder': '— Zuordnungslisten\u200E —' },
        name: 'checkboxlist_id',
    });
    const select_priority = $('<select>', {
        attr: {
            'data-placeholder': '— Priorität\u200E —',
            'data-op': 'OR',
        },
        name: 'priority_id',
    });

    const select_timestamp = $('<select>', {
        name: 'timestamp',
        attr: {
            'data-placeholder': '— Sortierungszeitstempel\u200E —',
            'data-op': 'OR',
        },
        css: { width: '30rem' },
        append: [
            $('<option>', { value: '', text: '— irrelevant —' }),
            $('<option>', { value: 'inserted', text: 'Eingangsstempel' }),
            $('<option>', { value: 'resubmit', text: 'Wiedervorlage' }),
            $('<option>', { value: 'lastseen', text: 'Zuletzt geöffnet' }),
            $('<option>', { value: 'updated',  text: 'Zuletzt bearbeitet' }),
        ],
    });
    setTimeout(function () {
        select_timestamp.kendoMultiSelect({
            autoClose: false,
            value: [],
        });
    }, 0);

    /**************************************************************************
     * TAGS
     *************************************************************************/

    const select_tags_placeholder = '— Schlagwörter\u200E —';

    const select_tags = $('<select>', {
        attr: { 'data-placeholder': select_tags_placeholder, },
        css: { width: '30rem' },
        name: 'tag_id',
        appendTo: $('<label>', {
            text: 'Schlagwörter: ',
            appendTo: select_tags_container,
        }),
    });

    const select_tags_callbacks = new_object();
    let select_tags_callbacks_callid = 0;

    const select_tags_datasource = new kendo.data.DataSource({
        data: [],
        transport: {
            batch: true,
            read ({ success }) {
                setTimeout(() => {
                    let name = select_tags_input.val().trim();
                    if (name === select_tags_placeholder) {
                        name = '';
                    }
                    const callid = ++select_tags_callbacks_callid;
                    select_tags_callbacks[`_${callid}`] = success;
                    send({ type: 'tagentries', name, callid });
                }, 0);
            },
        },
        schema: { model: { fields: {
            id: { type: 'number' },
            name: { type: 'string' },
        } } },
    });

    const select_tags_datasource_ids = new_object();

    select_tags.kendoMultiSelect({
        autoClose: false,
        dataTextField: 'name',
        dataValueField: 'id',
        dataSource: select_tags_datasource,
    });
    const select_tags_widget = select_tags.getKendoMultiSelect();
    const select_tags_input = select_tags_widget.input;

    /**************************************************************************
     * SEARCH PARAMETERS
     *************************************************************************/

    let last_query = null;
    let last_query_hash = null;

    function add_datetime (text, name, val) {
        const input = $('<input>', {
            name,
            val,
            placeholder: 'dd.mm.yyyy',
            css: {
                width: '30rem',
            },
        });
        setTimeout(function () {
            input.kendoDatePicker({
                format: 'dd.MM.yyyy',
                culture: 'de-DE',
            });
        });
        return $('<p>', {
            append: [
                $('<span>', { text }),
                input,
            ],
        });
    }

    function add_string (name, text) {
        return $('<p>', {
            append: $('<label>', {
                css: { display: 'inline-block' },
                text,
                append: $('<input>', { name, value: '' }),
            }),
        });
    }

    const ts_not_in_future = (function () {
        let [y, m, d] = date_to_array(new Date);
        ([y, m, d] = norm_array_date([y, m, d + 1, 12, 0, 0]));
        return `<${ prefixed_number(d, 2) }.${ prefixed_number(m, 2) }.${ prefixed_number(y, 4) }`;
    } ());

    const default_params = {
        inserted: `${ts_not_in_future} OR (NOT timestamp:inserted) OR index:0`,
        resubmit: `${ts_not_in_future} OR (NOT timestamp:resubmit) OR index:0`,
        index: '>0',
        flat: '',
    };

    const checkboxentry_container = make_div_cell([]);

    function negate (predicate) {
        const m = /^NOT \(([^)]+)\)$/.exec(predicate);
        return m ? m[1] : `NOT (${predicate})`;
    }

    function param_element_row (text, name, values) {
        return $('<p>', {
            text: text + ': ',
            append: values.map(([text, value, checked]) => {
                return $('<label>', {
                    css: { display: 'inline-block', padding: '0.1rem 0.3rem' },
                    text: ' ' + text,
                    prepend: $('<input>', {
                        type: 'radio',
                        name,
                        value,
                        attr: checked ? { checked: 'checked' } : {},
                    }),
                });
            }),
        });
    }

    function param_element_nym (text, name, selected) {
        const predicate = default_params[name];
        return param_element_row(text, name, [
            ['keine', predicate, selected === 0],
            ['nur', negate(predicate), selected === 1],
            ['egal', '', selected === 2],
        ]);
    }

    const param_form_bottom =  make_div_cell([
        make_box(null, {}, make_div_cell([
            add_string('title', 'Überschrift/Titel: '),
            add_string('textblock', 'Notiz (Inhalt): '),
            add_string('textblock_name', 'Notiz (Überschrift): '),
        ])),

        make_box(null, {}, make_div_cell([
            add_datetime('Eingangsstempel: ', 'inserted'),
            add_datetime('Wiedervorlage: ', 'resubmit'),
            add_datetime('Zuletzt geöffnet: ', 'lastseen'),
            add_datetime('Zuletzt bearbeitet: ', 'updated'),
            add_datetime('Gewählte Sortierung: ', 'relevant'),
        ])),

        make_box(null, {}, make_div_cell([
            $('<p>', { append: $('<label>', {
                text: 'Priorität (ODER-verknüpft): ',
                append: select_priority,
            }) }),
            select_tags_container,
            $('<p>', { append:  $('<label>', {
                text: 'Zeitstempel für Sortierung (ODER-verknüpft): ',
                append: select_timestamp,
            }) }),
            $('<p>', { append: $('<label>', {
                text: 'Zuordnungslisten: ',
                append: select_checkboxlist,
            }) }),
        ])),

        make_box(null, {}, checkboxentry_container),
    ]).css({ display: 'none' });

    const param_elements = [
        make_box(null, {}, [
            make_div_cell([
                $('<div>', {
                    append: $('<button>', {
                        type: 'button',
                        class: 'k-input k-button',
                        text: 'öffnen / anlegen',
                        on: { click (ev) {
                            ev.preventDefault();
                            send({ type: 'nextindex' });
                        } },
                    }),
                    css: { float: 'right' },
                }),
                $('<div>', {
                    css: { columns: 'auto 2' },
                    append: [
                        $('<div>', {
                            css: { display: 'inline-block' },
                            append: param_element_row('Flache Liste ohne Prioritäten', 'flat', [
                                ['Nein', '', 1],
                                ['Ja', '1'],
                            ]),
                        }),
                        $('<div>', {
                            css: { display: 'inline-block' },
                            append: param_element_nym('Archivierte Einträge', 'index', 0),
                        }),
                        $('<div>', {
                            css: { display: 'inline-block' },
                            append: param_element_nym('Wiedervorlagen in der Zukunft', 'resubmit', 2),
                        }),
                        $('<div>', {
                            css: { display: 'inline-block' },
                            append: param_element_nym('Eingangsstempel in der Zukunft', 'inserted', 2),
                        }),
                    ],
                }),
            ]),
        ]).css({
            display: 'block',
            padding: '0.25rem 0',
        }),
        make_box(null, {}, [
            make_div_cell($('<h2>', { append: $('<label>', {
                text: 'Suche ',
                css: { textAlign: 'center' },
                append: $('<input>', {
                    type: 'checkbox',
                    on: {
                        change (ev) {
                            if ($(this).is(':checked')) {
                                param_form_bottom.slideDown();
                            } else {
                                param_form_bottom.slideUp();
                            }
                        },
                    },
                }).trigger('change'),
            }) }) ),
            param_form_bottom,
        ]).css({
            display: 'block',
            padding: '0.25rem 0',
        }),
    ];
    const param_inputs = $('[name]', $('<div>', { append: param_elements }));
    const param_inputs_normal = param_inputs.filter('[type!=checkbox][type!=radio]');
    const param_inputs_checkable = param_inputs.filter('[type=checkbox],[type=radio]');

    const send_query = needs_dependency(throttle(ev => {
        if (ev) {
            ev.preventDefault();
        }

        const query = new_object();
        const hash_elems = new_object();

        function add_param (elem) {
            const { name, placeholder, type } = elem;
            const isntradio = (type !== 'radio');

            elem = $(elem);
            let value = elem.val();

            if (!value && isntradio) {
                return;
            } else if (value.join) {
                if (!value.length) {
                    return;
                }

                [].push.apply(
                    (hash_elems[name] || (hash_elems[name] = [])),
                    value,
                );

                value = map(
                    value,
                    value => `(${value})`,
                ).join(' ');
            } else {
                if (value.replace) {
                    // allowed:
                    //    space, parens, asterisk, hyphen, dot, digits,
                    //    colon, angle brackets, equals, at, upper,
                    //    square brackets, caret, lower, plus
                    value = (
                        value.
                        replace(/[\0-\x1f!"#$%&',/;?\\_`\x7f-\x9f]+/g, ' ').
                        replace(/ {2,}/g, ' ').
                        replace(/^ +| +$/g, '')
                    );

                    if (!value && isntradio) {
                        return;
                    }
                }

                (hash_elems[name] || (hash_elems[name] = [])).push(value);
                if (placeholder === 'dd.mm.yyyy') {
                    const es_date_value = date_to_es_value(value);
                    if (es_date_value) {
                        value = es_date_value;
                    }
                }

                if (value) {
                    value = `(${value})`;
                }
            }

            if (name in query) {
                query[name].value += ' ' + value;
            } else {
                query[name] = {
                    value,
                    op: elem.data('op') || 'AND',
                };
            }
        }

        forEach(param_inputs_normal, add_param);
        forEach(param_inputs_checkable.filter(':checked'), add_param);

        const new_query = stringify(query);
        if (new_query === last_query) {
            return;
        }

        forEach(default_params, (default_value, name) => {
            forEachRight(hash_elems[name] || [], (current_value, index, hash_elem) => {
                if (current_value === default_value) {
                    hash_elem.splice(index, 1);
                } else if (!current_value) {
                    hash_elem[index] = '!';
                } else if (current_value === negate(default_value)) {
                    hash_elem[index] = '!!';
                }
            }).length || delete hash_elems[name];
        });

        last_query = new_query;
        last_query_hash = hash_elems;

        const flat = !!(query.flat && query.flat.value);
        delete query.flat;
        send({
            type: 'list',
            flat,
            query,
            callid: ++current_callid,
        });
    }, 60));

    const params_form = $('<form>', {
        action: 'javascript:;',
        autocomplete: 'autocomplete',
        on: {
            submit (ev) {
                ev.preventDefault();
                send_query();
            }
        },
        class: 'hide-in-print',
        css: { display: 'none' },
        append: param_elements,
        insertBefore: form,
    }).on(CHANGE_EVENTS, '*', debounce(ev => {
        ev.stopPropagation();
        send_query();
    }, 600));
    needs_dependency(() => { params_form.css({ display: 'block' }); }, 1);

    /**************************************************************************
     * DISPLAY
     *************************************************************************/

    const ledgers_container = $('<div/>', { appendTo: form });

    const tagentries = got_dependency(function (msg) {
        const { callid, data } = msg;
        const success = select_tags_callbacks[`_${callid}`];
        delete select_tags_callbacks[`_${callid}`];
        if (success) {
            sort_by_name(data);
            success(data.filter(tagentry => {
                const { id, name } = tagentry;
                if (select_tags_datasource_ids[id] == null) {
                    select_tags_datasource_ids[id] = name;
                    return true;
                }
            }));
        }
    });

    const checkboxlists = got_dependency(function (msg) {
        const { data } = msg;
        sort_by_rank(data);
        forEach(data, ({ id: value, name, entries }) => {
            $('<option>', {
                value,
                text: name,
                appendTo: select_checkboxlist,
            });

            const ranks = mapValues(keyBy(entries, 'id'), 'rank');
            const append = sortBy(entries, [
                ({ parent_id, rank }) => (parent_id ? ranks[parent_id] : rank),
                ({ parent_id, rank }) => (parent_id ? rank : 0),
            ]).map(({ id, name }) => $('<option>', {
                value: id,
                text: name,
            }));

            const select_entries = $('<select>', {
                attr: { 'data-placeholder': `— ${name}\u200E —`, },
                css: { width: '30rem' },
                name: 'checkboxentry_id',
                append,
                appendTo: $('<label>', {
                    text: `${name}: `,
                    appendTo: $('<p>', { appendTo: checkboxentry_container }),
                }),
                kendoMultiSelect: { autoClose: false, value: [] },
            });
            [].push.call(param_inputs_normal, select_entries[0]);
        });
        select_checkboxlist.kendoMultiSelect({ autoClose: false, value: [] });
    });

    const priorities = got_dependency(function (msg) {
        const { data } = msg;
        sort_by_rank(data);
        forEach(data, ({ id, name }) => {
            $('<option>', {
                text: name,
                value: id,
                appendTo: select_priority,
            });
        });
        select_priority.kendoMultiSelect({ autoClose: false, value: [] });
    });

    function list (msg) {
        let { data, error, callid } = msg;

        if (callid !== current_callid) {
            return;
        }
        form.empty().append(ledgers_container.empty());

        const { length } = data;
        if (error) {
            notification.error(error);
        } else if (!length) {
            notification.info('Die Suche ergab keine Ergebnisse.');
        } else {
            notification.info(`Die Suche ergab ${length} Ergebnis(se).`);
            insert(msg);
        }

        ++ignore_hashchange;
        setTimeout(function () {
            --ignore_hashchange;
        }, 0);

        const hash = map(
            last_query_hash,
            (values, key) => (
                encodeURIComponent(key) +
                '=' +
                sort_by_string(map(values, encodeURIComponent)).join('/')
            ),
        ).join(',');
        history.replaceState(null, document.title, hash ? `#!${hash}` : '.');
    }

    function nextindex ({ ledger_id }) {
        kendo.prompt(
            'Welche Ablage wollen Sie öffnen. Die vorgewählte Nummer ist der kleinste freie Index.',
            `${ledger_id}`,
        ).then(index => {
            if (!index) {
                return;
            }
            index = +index;
            if (isFinite(index) && (index === index) && (index >= 0)) {
                location.href = `./${index}/`;
            }
        });
    }

    const send = make_ws(
        url,
        null,
        { list, tagentries, checkboxlists, priorities, nextindex },
    );
    send({ type: 'checkboxlists' });
    send({ type: 'priorities' });

    function hash_change_impl () {
        if (ignore_hashchange) {
            return;
        }

        ++ignore_hashchange;
        setTimeout(function () {
            setTimeout(function () {
                --ignore_hashchange;
            }, 0);
        }, 0);

        const e = /^(?:#|%23)?(?:%21|!)(.+)$/.exec(location.hash || '');
        if (e && (last_hash !== e[1])) {
            const params = new_object();

            last_hash = e[1];

            forEach(last_hash.split(/,/g), kv => {
                const m = /^([a-z_]+)=(.+)$/.exec(kv)
                if (!m) {
                    return;
                }

                const key = decodeURIComponent(m[1]);
                const inputs = $(`[name=${key}]`, params_form);
                if (!inputs || !inputs.length) {
                    return;
                }

                params[key] = {
                    inputs: (inputs.is('[type=radio]') ? [inputs] : inputs),
                    values: map(map(m[2].split(/[/]/g), decodeURIComponent), value => {
                        switch (value) {
                            case '!': return '';
                            case '!!': return negate(default_params[key]);
                        }
                        return value;
                    }),
                }
            });

            params_form[0].reset();

            setTimeout(function () {
                forEach(params, ({inputs, values}) => {
                    forEach(inputs, (input, key) => {
                        input = $(input);
                        const multiselect = input.getKendoMultiSelect();
                        if (multiselect) {
                            input.val(values);
                            multiselect.value(values);
                        } else {
                            forEach(values, new_value => {
                                some(input, i => {
                                    const { type, value } = i;
                                    if (type === 'radio' && value === new_value) {
                                        i.checked = true;
                                        return true;
                                    }
                                }) || input.filter(':not([type=radio])').eq(0).val(new_value);
                            });
                        }
                    });
                });
            }, 0);
        }

        setTimeout(function () {
            send_query();
        }, 0);
    }

    let last_hash = new_object();
    const on_hashchange = needs_dependency(hash_change_impl);

    on_hashchange();
    $(window).on('hashchange', on_hashchange);

    return ledgers_container;
};
function ablage_get () {
    const form = $('#form');
    form.on({
        submit (ev) {
            ev.preventDefault();
        },
    });
    const { url, id, index, is_new } = form.data('data');

    enable_notifications(form);

    if (is_new) {
        notification.success(`Die Umlaufmappe #${prefixed_number(index, 3)} wurde neu angelegt.`);
    }

    const priority_by_id = new_object();
    const textblock_by_id = new_object();
    const checkboxlist_by_id = new_object();
    const checkboxrow_by_id = new_object();
    const color_by_priority = new_object();

    const new_li = (name, value, text) => {
        return $('<li>', {
            css: {
                paddingLeft: 0,
            },
            append: $('<label>', { append: [
                $('<input>', {
                    type: 'radio',
                    name,
                    value,
                    css: {
                        width: 'unset',
                    },
                }),
                $('<span>', { text }),
            ] }),
        });
    };

    const [got_dependency, needs_dependencies] = make_function_with_depencies();

    const top_block = (text, content) => $('<div>', {
        css: {
            display: 'inline-block',
            verticalAlign: 'top',
            padding: '0.25rem 0.5rem',
        },
        append: [
            $('<h3>', {
                css: { marginTop: 0 },
                text,
            }),
            content,
        ],
    })[0];

    /**************************************************************************
     * TAGS
     *************************************************************************/

    const select_tags_container = $('<div/>');

    const select_tags_placeholder = 'Bitte wählen …';

    const select_tags = $('<select>', {
        attr: {
            'data-placeholder': select_tags_placeholder,
        },
        css: {
            width: '30rem',
        },
        appendTo: select_tags_container,
    });

    const select_tags_callbacks = new_object();
    let select_tags_callbacks_callid = 0;

    const select_tags_datasource = new kendo.data.DataSource({
        data: [],
        transport: {
            batch: true,
            read ({ success }) {
                setTimeout(() => {
                    let name = select_tags_input.val().trim();
                    if (name === select_tags_placeholder) {
                        name = '';
                    }
                    const callid = ++select_tags_callbacks_callid;
                    select_tags_callbacks[`_${callid}`] = success;
                    send({ type: 'tagentries', name, callid });
                }, 0);
            },
        },
        schema: { model: { fields: {
            id: { type: 'number' },
            name: { type: 'string' },
        } } },
    });

    const select_tags_options = {
        autoClose: false,
        dataTextField: 'name',
        dataValueField: 'id',
        dataSource: select_tags_datasource,
        noDataTemplate () {
            let name = select_tags_input.val().trim();
            if (!name || (name === select_tags_placeholder)) {
                return;
            }

            return $('<div>', {
                css: {
                    color: '#000',
                    textTransform: 'none',
                    fontWeight: 'normal',
                    fontSize: '1rem',
                },
                append: [
                    $('<p>', { text: `Tag „${ name }“existiert noch nicht.` }),
                    $('<p>', { append: $('<label>', { append: $('<button>', {
                        type: 'button',
                        class: 'k-button',
                        text: 'Hinzufügen',
                        on: {
                            click (ev) {
                                ev.preventDefault();
                                send({
                                    type: 'tagentry',
                                    name,
                                });
                            },
                        },
                    }) }) }),
                ],
            });
        },
        select (ev) {
            const { dataItem: { id } } = ev;
            send({ type: 'tagset', id, set: true })
        },
        deselect (ev) {
            const { dataItem: { id } } = ev;
            send({ type: 'tagset', id, set: false })
        },
    };

    const select_tags_datasource_ids = new_object();

    select_tags.kendoMultiSelect(select_tags_options);
    const select_tags_widget = select_tags.getKendoMultiSelect();
    const select_tags_input = select_tags_widget.input;

    /**************************************************************************
     * TIMESTAMPS
     *************************************************************************/

    const select_timestamp_container = $('<div>', {
        css: {
            columns: '2',
            display: 'inline',
        },
    });
    select_timestamp_container.on('change', '[name=timestamp]', (ev) => {
        const { currentTarget } = ev;
        const self = $(currentTarget);
        if (self.is(':checked')) {
            $('[name=timestamp]', select_timestamp_container).prop({
                readonly: true,
                disabled: true,
            });
            send({
                type: 'timestamp',
                value: self.attr('value'),
            });
        }
    });
    const select_timestamp_container1 = $('<div>', {
        appendTo: select_timestamp_container,
        css: {
            display: 'inline-block',
            paddingRight:'0.5rem',
        },
    });
    const select_timestamp_container2 = $('<div>', {
        appendTo: select_timestamp_container,
        css: { display: 'inline-block' },
    });

    const make_timestamp_text = (text, value) => $('<label>', {
        text,
        append: $('<input>', {
            type: 'radio',
            name: 'timestamp',
            value,
            css: {
                float: 'left',
                width: 'unset',
                margin: '0.2rem 0.5rem',
            },
        }),
    });

    const timestamp_inserted = make_timestamp_input(
        select_timestamp_container1,
        make_timestamp_text('Eingangsstempel', 'inserted'),
        value => { send({ type: 'inserted', value }); },
        '<span>',
    );

    const timestamp_resubmit = make_timestamp_input(
        select_timestamp_container1,
        make_timestamp_text('Wiedervorlage', 'resubmit'),
        value => { send({ type: 'resubmit', value }); },
        '<span>',
    );

    const timestamp_updated = make_timestamp_input(
        select_timestamp_container2,
        make_timestamp_text('Zuletzt aktualisiert', 'updated'),
        null,
        '<span>',
    );
    timestamp_updated.enable(false);

    const timestamp_lastseen = make_timestamp_input(
        select_timestamp_container2,
        make_timestamp_text('Zuletzt gesehen', 'lastseen'),
        null,
        '<span>',
    );
    timestamp_lastseen.enable(false);

    /**************************************************************************
     * BASIC LAYOUT
     *************************************************************************/

    const list_priorities = $('<ul>', {
        change (ev) {
            send({
                type: 'priority',
                id: $('input:checked', list_priorities).val(),
            });
        },
    });

    const div_textblocks = $('<div>');
    make_sortable_ranking(div_textblocks, (ev) => {
        const { oldIndex, newIndex, item } = ev;
        const { id } = item.data();
        send({ type: 'textblocksort', id, oldIndex, newIndex });
    });

    const div_checkboxlist = $('<div>', {
        change (ev) {
            const { target } = ev;
            const { value, checked } = target;
            target.readonly = 'readonly';
            target.disabled = 'disabled';
            send({
                type: 'checkboxset',
                id: value,
                set: checked,
            });
        },
    });

    let old_title = null;
    const title_textbox = $('<input>', {
        class: 'k-input',
        css: {
            fontSize: '2rem',
            lineHeight: '1.2em',
            width: '60rem',
            maxWidth: '100%',
        },
    }).on(CHANGE_EVENTS, debounce(ev => {
        const new_title = title_textbox.val();
        if (new_title && (new_title !== old_title)) {
            old_title = new_title;
            send({
                type: 'title',
                value: new_title,
            });
        }
    }, 360));

    function traverse_btn (direction, title, icon) {
        return $('<label>', {
            title,
            append: $('<button>', {
                class: 'k-button',
                append: $('<img>', {
                    src: `https://bib.vetmed.fu-berlin.de/static/icons/public-domain-icons/30e0a35d/${icon}.svg`,
                    css: {
                        width: '1rem',
                        height: '1rem',
                    },
                }),
                type: 'button',
                css: {
                    float: 'right',
                    marginTop: '0.65rem',
                },
                on: {
                    click (ev) {
                        ev.preventDefault();
                        send({ type: 'traverse', direction, index });
                    },
                }
            }),
        });
    }

    const traverse_btns = index ? $('<div>', {
        css: {
            float: 'right',
            marginTop: '0.65rem',
        },
        append: [
            traverse_btn('first', 'Ganz zum Anfang', 'symbol_previous'),
            traverse_btn('prev', 'Vorige Mappe', 'symbol_left_chevron_chevron_left_direction'),
            traverse_btn('next', 'Nächste Mappe', 'symbol_right_chevron_chevron_right_direction'),
            traverse_btn('last', 'Ganz ans Ende', 'symbol_next'),
        ],
    }) : $('<span>');

    const move_btn = $('<button>', {
        class: 'k-button',
        text: 'verschieben / archivieren',
        type: 'button',
        css: {
            float: 'right',
            marginTop: '0.65rem',
        },
        on: {
            click (ev) {
                ev.preventDefault();
                kendo.prompt(
                    'Welchen Index soll die Mappe tragen? Zum Archivieren eine Null eingeben.',
                ).then(new_index => {
                    if (!new_index) {
                        return;
                    }

                    new_index = +new_index;
                    if (!isFinite(new_index) || (new_index === index) || (new_index < 0) || (new_index >= 1000000000000)) {
                        return;
                    }

                    if (new_index === 0) {
                        send({
                            type: 'title',
                            value: `#${prefixed_number(index, 3)} ${old_title}`,
                        });
                    }

                    send({
                        type: 'move',
                        index: new_index,
                    });
                });
            },
        }
    });

    const div_ledger = $('<div>', {
        css: {
            background: 'rgb(69,69,69)',
            boxShadow: '0 0 0.3ex #000',
            border: '0.3rem solid',
            borderColor: '#fff',
        },
        append: [
            $('<div>', {
                css: {
                    verticalAlign: 'top',
                    backgroundColor: 'rgb(107,158,31)',
                    padding: '0.55rem',
                    margin: '0',
                },
                append: [
                    traverse_btns,
                    move_btn,
                    $('<label>', {
                        css: { display: 'block', textAlign: 'left' },
                        append: title_textbox,
                    }),
                ],
            }),
            $('<div>', {
                css: {
                    verticalAlign: 'top',
                    backgroundColor: '#fff',
                    padding: '0.5rem',
                    margin: '0rem',
                },
                append: [
                    top_block('Prioritäten', list_priorities),
                    top_block('Zeitstempel', $('<div>', {
                        css: { display: 'inline-block' },
                        append: select_timestamp_container,
                    })),
                    top_block('Schlagwörter', select_tags_container),
                ],
            }),
            $('<div>', {
                css: {
                    backgroundColor: 'rgb(221,221,221)',
                    padding: '0.5rem',
                    margin: '0rem',
                },
                append: [
                    $('<h3>', {
                        css: { marginTop: 0, padding: '0.25rem 0 0 0.55rem' },
                        text: 'Freitextnotizen ',
                        append: $('<span>', {
                            css: { fontSize: '1rem' },
                            append: $('<button>', {
                                css: { padding: '0 0.5rem' },
                                type: 'button',
                                class: 'k-button',
                                text: '➕',
                                on: {
                                    click (ev) {
                                        ev.preventDefault();
                                        kendo.prompt(
                                            'Wie soll der neue Textblock heißen?',
                                        ).then(name => {
                                            name && send({
                                                'type': 'textblock',
                                                name,
                                            });
                                        });
                                    },
                                },
                            }),
                        }),
                    }),
                    div_textblocks,
                ],
            }),
            $('<div>', {
                css: {
                    backgroundColor: '#fff',
                    padding: '0.5rem',
                    margin: '0rem',
                },
                append: [
                    $('<h3>', {
                        css: { marginTop: 0, padding: '0.25rem 0 0 0.55rem' },
                        text: 'Zuordnung',
                    }),
                    div_checkboxlist,
                ],
            }),
        ],
        appendTo: form,
    });

    function insert_textbox (data) {
        const { id } = data;
        const div = new_textbox(data, 'textblock', send);
        $('textarea', div).css({ width: '40rem', height: '15em' });

        const old_textblock = textblock_by_id[id];
        if (old_textblock) {
            old_textblock.replaceWith(div);
        }

        textblock_by_id[id] = div;
        return div.appendTo(div_textblocks);
    }

    /**************************************************************************
     * CALLBACKS
     *************************************************************************/

    function checkboxentry (data, paddingLeft) {
        const { id, name } = data;
        const div = $('<li>', {
            css: { paddingLeft },
            append: [
                $('<label>', { append: [
                    $('<input>', {
                        type: 'checkbox',
                        val: id,
                        css: {
                            marginRight: '0.5rem',
                            width: 'unset',
                        },
                    }),
                    $('<span>', { text: name })
                ] }),
                $('<ul>', {
                    css: {
                        margin: '0 0 0 0.5rem',
                    },
                }),
            ],
        });
        checkboxrow_by_id[id] = div;
        return div;
    }

    function checkboxlist (msg) {
        const { data } = msg;
        const { id, color, entries, name } = data;
        sort_by_rank(entries);

        const entries_ul = $('<ul>');
        forEach(entries, entry => {
            const { parent_id } = entry;
            if (parent_id == null) {
                checkboxentry(entry, 0).appendTo(entries_ul);
            }
        });
        forEach(entries, entry => {
            const { parent_id } = entry;
            if (parent_id != null) {
                checkboxentry(entry, '1.5rem').appendTo(checkboxrow_by_id[parent_id]);
            }
        });

        const checkboxlist_div = make_box(color, { entries_ul }, [
            make_div_cell($('<strong>', { text: name })),
            make_div_cell(entries_ul),
        ]);
        checkboxlist_by_id[id] = checkboxlist_div;
        checkboxlist_div.appendTo(div_checkboxlist);
    }

    const checkboxlists = got_dependency(make_list_fn(checkboxlist));

    function priority (msg) {
        const { id } = msg;
        if (id != null) {
            const priority = priority_by_id[id];
            if (priority) {
                $('input:first', priority).prop('checked', true);
            }

            const borderColor = color_by_priority[id];
            if (borderColor) {
                div_ledger.css({ borderColor });
            }
        }
    }

    const priorities = got_dependency(function (msg) {
        const { data } = msg;
        sort_by_rank(data);
        forEach(data, ({ id, rank, name, color, isdefault }) => {
            const li = new_li('priority', id, name).appendTo(list_priorities);
            if (isdefault !== null) {
                $('input:first', li).prop('checked', true);
            }
            priority_by_id[id] = li;
            color_by_priority[id] = color;
        });
    });

    const ledger = needs_dependencies(function (msg) {
        const { data } = msg;
        const {
            id, resubmit, inserted, updated, lastseen, timestamp,
            textblocks, tagsets, checkboxsets, priority_id, title,
        } = data;
        sort_by_rank(textblocks);

        old_title = title;

        forEach(textblocks, insert_textbox);

        forEach(checkboxsets, ({checkboxentry_id}) => {
            const checkboxrow = checkboxrow_by_id[checkboxentry_id];
            if (checkboxrow) {
                $('input:first', checkboxrow).prop('checked', true);
            }
        });

        priority({ id: priority_id });

        sort_by_string(tagsets, ({ tagentry: { name } }) => name);
        forEach(tagsets, ({ tagentry }) => {
            const { id, name } = tagentry;
            if (!select_tags_datasource_ids[id]) {
                select_tags_datasource.add(tagentry);
                select_tags_datasource_ids[id] = name;
            }
            select_tags_widget.value(select_tags_widget.value().concat([id]));
        });

        timestamp_inserted.value(parse_time(inserted));
        timestamp_resubmit.value(parse_time(resubmit));
        timestamp_updated.value(parse_time(updated));
        timestamp_lastseen.value(parse_time(lastseen));

        $(`[name=timestamp][value="${timestamp}"]`, select_timestamp_container).prop({
            checked: true,
        });

        title_textbox.val(title);
    });

    function textblockname (msg) {
        // TODO
    }

    const textblockcolor = make_colorfn(notification, textblock_by_id, 'Textblock');

    function textblockvalue (msg) {
        // TODO
    }

    function checkboxset (msg) {
        const { id, set } = msg;
        const entry = checkboxrow_by_id[id];
        if (entry) {
            $('input:first', entry).prop('checked', set).removeAttr('readonly disabled');
        }
    }

    function textblock (msg) {
        const { data } = msg;
        if (!data) {
            notification.warning('Der Textblock konnte nicht angelegt werden!');
        } else {
            insert_textbox(data);
        }
    }

    function textblockremove (msg) {
        const { id, count } = msg;
        const [ num_textblock ] = count;

        const textblock = textblock_by_id[id];
        delete textblock[id]
        if (textblock) {
            textblock.hide(function () {
                textblock.remove();
            });
            notification.success('Textblock gelöscht. #Textblock: ' + num_textblock);
        }
    }

    const tagentries = got_dependency(function (msg) {
        const { callid, data } = msg;
        const success = select_tags_callbacks[`_${callid}`];
        delete select_tags_callbacks[`_${callid}`];
        if (success) {
            sort_by_name(data);
            success(data.filter(tagentry => {
                const { id, name } = tagentry;
                if (select_tags_datasource_ids[id] == null) {
                    select_tags_datasource_ids[id] = name;
                    return true;
                }
            }));
        }
    });

    function tagentry (msg) {
        let data, name, id;
        ({ data, name } = msg);
        if (!data) {
            notification.warning(`Tag konnte nicht angelegt werden: „${ name }“`);
            return;
        }

        ({ id, name } = data);
        if (!select_tags_datasource_ids[id]) {
            select_tags_datasource.add(data);
            select_tags_datasource_ids[id] = name;
        }
        select_tags_widget.value(select_tags_widget.value().concat([id]));
    }

    function inserted ({ value }) {
        timestamp_inserted.value(parse_time(value));
    }

    function resubmit ({ value }) {
        timestamp_resubmit.value(parse_time(value));
    }

    function title ({ title }) {
        notification.success(`Der Titel wurde geändert: „${title}“`);
    }

    function timestamp ({ timestamp }) {
        if (timestamp) {
            $(`[name=timestamp][value="${timestamp}"]`, select_timestamp_container).prop({
                checked: true,
            });
        }
        $('[name=timestamp]', select_timestamp_container).removeAttr('readonly disabled');
    }

    function move ({ url }) {
        if (url) {
            notification.success('Verschoben');
            setTimeout(function (url) {
                location.replace(url);
            }, 300, url);
        } else {
            notification.info('Vermutlich existiert bereits eine Mappe mit dieser Nummer.');
            notification.error('Die Mappe konnte nicht verschoben werden.');
        }
    }

    function traverse ({ index, url }) {
        if (url) {
            location.href = url;
        } else {
            notification.info('In diese Richtung gibt es keine weiteren Umlaufmappen.');
        }
    }

    const send = make_ws(
        url,
        () => {
            send({ type: 'checkboxlists' });
            send({ type: 'priorities', trash: !index });
            send({ type: 'ledger' });
        },
        {
            checkboxlist, checkboxlists, priority, priorities, ledger,
            textblockname, textblockcolor, textblockvalue, checkboxset, textblock,
            textblockremove, tagentries, tagentry, inserted, resubmit, title,
            timestamp, move, traverse,
        },
    );
}
function ablage_kalender () {
    let calendar_sheets_by_ym;
    const ledgers_container = ablage_list_common(insert);

    function get ({ id, index, relevant, title, timestamp, priority }) {
        const { color, rank } = priority || {};

        relevant = parse_time(relevant);
        if (!relevant) {
            notification.error(`Datenfehler bei Mappe ~${id}~!`);
            console.log('Could not parse "relevant"', {id, relevant});
            return;
        }

        const [y, m, d] = date_to_array(relevant);
        const ym = prefixed_number(y, 4) + prefixed_number(m, 2);

        let calendar_days;
        const calendar_sheet_data = calendar_sheets_by_ym[ym];
        if (calendar_sheet_data) {
            ([calendar_days] = calendar_sheet_data);
        } else {
            const header = `${MONTHS[m - 1]} ${prefixed_number(y, 4)}`;
            const calendar_li = $('<li>', { text: header });
            const calendar_sheet = $('<div>', {
                css: {
                    display: 'flex',
                    flexGrow: 1,
                    flexShrink: 1,
                    flexWrap: 'wrap',
                },
            });

            function entry () {
                return $('<div>', {
                    css: {
                        width: '13.5%',  // 1/8 < 13.5% < 14% < 1/7
                        margin: '0.25%',
                    },
                    appendTo: calendar_sheet,
                });
            }

            const first_dom = new Date(y, m - 1, 1).getDay();
            const month_length = new Date(y, m, 0).getDate();

            $('<h2>', {
                text: header,
                css: {
                    textAlign: 'center',
                    width: '100%',
                },
                appendTo: calendar_sheet,
            });

            forEach(DAYS, text => {
                entry().css({
                    textAlign: 'center',
                    fontWeight: 'bold',
                    padding: '0 0 0.3rem 0',
                }).text(text);
            });
            times((6 + first_dom) % 7, entry);
            calendar_days = times(month_length, index => {
                const day_content = $('<ul>', { rank: -1 });
                $('<div>', {
                    class: 'outer',
                    css: {
                        width: '13.5%',  // 1/8 < 13.5% < 14% < 1/7
                        background: '#f8f8f8',
                        boxShadow: '0 0 0.3ex #000',
                        border: '0.3rem solid',
                        borderColor: '#ffffff',
                        margin: '0.25%',
                    },
                    append: $('<div>', {
                        append: [
                            $('<p>', {
                                css: {
                                    fontWeight: 'bold',
                                    paddingLeft: '0.3rem',
                                },
                                text: `${index + 1}.`,
                            }),
                            day_content,
                        ],
                    }),
                    appendTo: calendar_sheet,
                });
                return day_content;
            });

            calendar_sheets_by_ym[ym] = [calendar_days, calendar_li, calendar_sheet];
        }

        const calendar_day = calendar_days[d - 1];
        calendar_day.append($('<li>', {
            append: $('<a>', {
                href: index ? `../ablage/${index}/` : `../archiv/${id}/`,
                append: [
                    $('<strong>', {
                        css: { fontSize: '1.1rem' },
                        text: (index ? '#' + prefixed_number(index, 3) : '~' + id + '~'),
                    }),
                    $('<span>', {
                        text: ` ${title}`,
                    }),
                ],
            }),
        }));

        const cur_rank = calendar_day.data('rank');
        if (rank && (rank > 0) && (!cur_rank || (cur_rank < 0) || (cur_rank > rank))) {
            calendar_day.data('rank', rank)
            calendar_day.closest('.outer').css({ borderColor: color });
        }
    }

    function insert ({ data }) {
        calendar_sheets_by_ym = new_object();

        const inner_container = $('<div>')
        const ul = $('<ul>', { appendTo: inner_container });

        forEach(data, get);
        const yms = Object.keys(calendar_sheets_by_ym).sort((a, b) => (+a - +b));
        if (!yms.length) {
            return;
        }

        forEach(yms, ym => {
            const [calendar_days, calendar_li, calendar_sheet] = calendar_sheets_by_ym[ym];
            ul.append(calendar_li);
            inner_container.append(calendar_sheet);
        });

        inner_container.appendTo(ledgers_container);

        const yms_first = yms[0];
        const yms_last = yms[yms.length - 1];
        if (yms_first === yms_last) {
            ul.remove();
            return;
        }

        inner_container.kendoTabStrip({ animation: false });

        let [y, m] = date_to_array(new Date);
        let ym;
        while (true) {
            ym = prefixed_number(y, 4) + prefixed_number(m, 2);
            if (ym >= yms_last) {
                ym = yms_last;
                break;
            } else if (calendar_sheets_by_ym[ym]) {
                break;
            }

            ([y, m] = norm_array_date([y, m + 1, 15, 12, 0, 0]));
        }

        inner_container.getKendoTabStrip().activateTab(calendar_sheets_by_ym[yms_first][1]);
        inner_container.getKendoTabStrip().activateTab(calendar_sheets_by_ym[yms_last][1]);
        inner_container.getKendoTabStrip().activateTab(calendar_sheets_by_ym[ym][1]);
    }
}
function ablage_list () {
    let priority_content_by_rank, priority_by_rank, today;
    const ledgers_container = ablage_list_common(insert);

    function get ({ id, index, priority, relevant, title, timestamp, days_relevant }) {
        const {
            name: priority_name,
            color: priority_color,
            rank: priority_rank = 0,
            id: priority_id,
        } = priority || {};

        let priority_content = priority_content_by_rank[priority_rank];
        if (!priority_content) {
            priority_content = priority_content_by_rank[priority_rank] = make_div_cell([]);
            priority_by_rank[priority_rank] = make_box(
                priority_color,
                { rank: priority_rank },
                (priority_id ? [make_h2_cell(`Priorität: ${priority_name}`), priority_content] : priority_content),
            ).addClass('hide-border-in-print').css({
                display: 'block',
                padding: '0.25rem 0',
            });
        }

        const timestamp_div = $('<div>');
        const timestamp_inserted = make_timestamp_input(
            timestamp_div,
            [$('<span>', { 
                text: {
                    resubmit: 'Wiedervorlage',
                    inserted: 'Eingangsstempel',
                    updated: 'Bearbeitet',
                    lastseen: 'Gesehen',
                }[timestamp] + ': ',
                append: linear_to_name(days_relevant - today),
            }), $('<br>')],
        );
        timestamp_inserted.enable(false);
        timestamp_inserted.value(parse_time(relevant));

        make_box(priority_color, {}, [
            make_div_cell($('<a>', {
                css: {
                    display: 'block',
                    padding: '0.5rem',
                },
                append: [
                    $('<strong>', {
                        css: { fontSize: '1.2rem' },
                        text: (index ? '#' + prefixed_number(index, 3) : '~' + id + '~'),
                    }),
                    $('<span>', {
                        css: { fontSize: '1.2rem' },
                        text: ` ${title}`,
                    }),
                ],
                href: index ? `./${index}/` : `../archiv/${id}/`,
            })).css({
                padding: 0,
                maxHeight: '3.5em',
                overflow: 'hidden',
            }),
            make_div_cell(timestamp_div),
        ]).css({
            width: '28rem',
        }).appendTo(priority_content);
    }

    function insert ({ data, today: today_ }) {
        today = today_;
        priority_content_by_rank = new_object();
        priority_by_rank = new_object();

        data = sortBy(data, [
            'days_relevant', 'days_inserted', 'days_updated', 'days_resubmit',
            'index', 'id',
        ]);
        forEach(data, get);
        forEach(
            Object.keys(priority_by_rank).sort((a, b) => (+a - +b)),
            rank => { priority_by_rank[rank].appendTo(ledgers_container) },
        );
    }
}
function ablage_tabelle () {
    let priority_content_by_rank, today, tbl;
    const ledgers_container = ablage_list_common(insert);

    function get ({ id, index, priority, title, timestamp, days_relevant }) {
        const {
            name: priority_name,
            rank: priority_rank = 0,
            color,
        } = priority || {};

        let priority_content = priority_content_by_rank[priority_rank];
        if (!priority_content) {
            priority_content = priority_content_by_rank[priority_rank] = [];
        }

        priority_content.push($('<tr/>', {
            append: [
                $('<td/>', {
                    css: {
                        whiteSpace: 'nowrap',
                    },
                    text: (index ? '#' + prefixed_number(index, 3) : '~' + id + '~'),
                }),
                $('<td/>', {
                    css: {
                        width: '99%',
                    },
                    append: $('<a/>', {
                        href: index ? `../ablage/${index}/` : `../archiv/${id}/`,
                        text: title,
                    }),
                }),
                $('<td/>', {
                    css: {
                        whiteSpace: 'nowrap',
                    },
                    append: [
                        $('<span>', {
                            css: { display: 'none' },
                            text: prefixed_number(days_relevant, 15),
                        }),
                        document.createTextNode(' '),
                        linear_to_name(days_relevant - today),
                    ],
                }),
                $('<td/>', {
                    css: {
                        whiteSpace: 'nowrap',
                    },
                    text: {
                        resubmit: 'Wiedervorlage',
                        inserted: 'Eingangsstempel',
                        updated: 'Bearbeitet',
                        lastseen: 'Gesehen',
                    }[timestamp],
                }),
                $('<td/>', {
                    css: {
                        whiteSpace: 'nowrap',
                        boxShadow: `0 0 0 0.2rem ${color || '#fff'} inset`,
                    },
                    append: [
                        $('<span>', {
                            css: { display: 'none' },
                            text: prefixed_number(priority_rank, 15),
                        }),
                        document.createTextNode(' ' + priority_name),
                    ],
                }),
            ],
        }));
    }

    function insert ({ data, today: today_ }) {
        today = today_;
        priority_content_by_rank = new_object();

        if (tbl && tbl.length) {
            tbl.remove();
        }

        tbl = $('<table/>', {
            css: {
                width: '100%',
            },
            append: [
                $('<thead/>', {
                    append: $('<tr/>', {
                        append: [
                            $('<th/>', { text: '#' }),
                            $('<th/>', { text: 'Titel' }),
                            $('<th/>', { text: 'Wann' }),
                            $('<th/>', { text: 'Was' }),
                            $('<th/>', { text: 'Priorität' }),
                        ],
                    }),
                }),
            ],
        });
        const tbody = $('<tbody/>', { appendTo: tbl });

        data = sortBy(data, [
            'days_relevant', 'days_inserted', 'days_updated', 'days_resubmit',
            'index', 'id',
        ]);
        forEach(data, get);
        forEach(
            Object.keys(priority_content_by_rank).sort((a, b) => (+a - +b)),
            rank => { tbody.append(priority_content_by_rank[rank]) },
        );
        tbl.tablesorter();
        tbl.appendTo(ledgers_container);
    }
}
function defaulttextblock_list () {
    const form = $('#form');
    form.on({
        submit (ev) {
            ev.preventDefault();
        },
    });
    const { url } = form.data();

    $(form).on('keypress', 'input[type=text]', ev => {
        const { keyCode, which } = ev;
        const key = (keyCode || which);
        if (key === 10 || key === 13) {
            ev.preventDefault();
        }
    })

    $('<div/>', {
        append: [
            $('<button/>', {
                class: 'k-button',
                text: 'Neuer Textblock',
                on: {
                    click (ev) {
                        kendo.prompt(
                            'Wie soll der neue Textblock heißen?',
                        ).then(name => {
                            name && send({
                                'type': 'create',
                                name,
                            });
                        });
                    },
                },
            }),
        ],
        appendTo: form,
    });

    const defaulttextblocks_container = $('<div/>', {
        appendTo: form,
    });
    make_sortable_ranking(defaulttextblocks_container, (ev) => {
        const { oldIndex, newIndex, item } = ev;
        const { id } = item.data();
        send({ type: 'sort', id, oldIndex, newIndex });
    });

    enable_notifications(form);

    const defaulttextblocks_by_id = new_object();

    function get (msg) {
        const { data } = msg;
        const { id } = data;
        const div = new_textbox(data, '', send);
        defaulttextblocks_by_id[id] = div;
        div.appendTo(defaulttextblocks_container);
        return div;
    }

    const list = make_list_fn(get);

    function create (msg) {
        get(msg);
    }

    const color = make_colorfn(defaulttextblocks_by_id, defaulttextblocks_by_id, 'Textblock');

    function remove (msg) {
        const { id, count } = msg;
        const [ num_defaulttextblock ] = count;

        const defaulttextblock = defaulttextblocks_by_id[id];
        delete defaulttextblock[id]
        if (defaulttextblock) {
            defaulttextblock.hide(function () {
                defaulttextblock.remove();
            });
            notification.success('Textblock gelöscht. #Textblock: ' + num_defaulttextblock);
        }
    }

    const send = make_ws(
        url,
        () => { send({ type: 'list' }) },
        { list, get, create, remove, color },
    );
}
function login () {
    const form = $('#form');
    const name = $('[name=fu-name]', form);
    const password = $('[name=fu-pw]', form);
    const { url } = form.data();

    function nonce (ws, msg) {
        const { reason } = msg;
        if (reason) {
            alert(reason)
            ws.close();
            return;
        }

        const cred_name = name.val().toLowerCase();
        const cred_pw = password.val();
        if (!cred_name || !cred_pw) {
            return;
        }
        password.val('');

        const response = sasl_digest_md5(msg, cred_name, cred_pw);
        console.log('>', response);
        ws.send(stringify(response));
    }

    function next (ws, msg) {
        ws.close();

        const { next, data } = msg;
        $('<form>', {
            method: 'POST',
            action: next,
            append: $('<input>', {
                type: 'hidden',
                name: 'data',
                val: data,
            }),
            css: { display: 'none' },
            insertAfter: form,
        }).submit();
    }

    const functions = { nonce, next };
    form.on({
        submit (ev) {
            ev.preventDefault();

            const ws = new WebSocket(url);
            $(ws).on({
                message (ev) {
                    ev.preventDefault();
                    const msg = parse(ev.originalEvent.data);
                    console.log('<', msg);
                    const { type } = msg;
                    (functions[type] || noop)(ws, msg);
                },
                error (ev) {
                    alert('Error.');
                },
            });
        },
    });
}
function priority_list () {
    const form = $('#form');
    form.on({
        submit (ev) {
            ev.preventDefault();
        },
    });
    const { url } = form.data();

    $(form).on('keypress', 'input[type=text]', ev => {
        const { keyCode, which } = ev;
        const key = (keyCode || which);
        if (key === 10 || key === 13) {
            ev.preventDefault();
        }
    })

    $('<div/>', {
        append: [
            $('<button/>', {
                class: 'k-button',
                text: 'Neue Priorität',
                on: {
                    click (ev) {
                        kendo.prompt(
                            'Wie soll die neue Priorität heißen?',
                        ).then(name => {
                            name && send({
                                'type': 'create',
                                name,
                            });
                        });
                    },
                },
            }),
        ],
        appendTo: form,
    });

    const priorities_container = $('<div/>', {
        appendTo: form,
    });
    make_sortable_ranking(priorities_container, (ev) => {
        const { oldIndex, newIndex, item } = ev;
        const { id } = item.data();
        send({ type: 'sort', id, oldIndex, newIndex });
    });

    enable_notifications(form);

    const priorities_by_id = new_object();
    const btns_by_id = new_object();
    let btn_trash_set = undefined;
    let btn_default_set = undefined;

    function get (msg) {
        const { data } = msg;
        const { id, name, color, active, isdefault, istrash } = data;

        if ({}.hasOwnProperty.call(priorities_by_id, id)) {
            priorities_by_id[id].remove();
            delete priorities_by_id[id];
            delete btns_by_id[id];
        }

        const name_input = make_name_input(name, make_sendfn(send, id, 'name', 'name'));

        const btn_default = $('<button>', {
            type: 'button',
            text: 'zum Standard machen',
            class: 'k-button',
            on: {
                click (ev) {
                    ev.preventDefault();
                    send({ type: 'isdefault', id });
                },
            },
        });
        if (isdefault != null) {
            btn_default_set = btn_default;
            btn_default.prop({readonly:true, disabled:true});
        }

        const btn_trash = $('<button>', {
            type: 'button',
            text: 'zum Mülleimer machen',
            class: 'k-button',
            on: {
                click (ev) {
                    ev.preventDefault();
                    send({ type: 'istrash', id });
                },
            },
        });
        if (istrash != null) {
            btn_trash_set = btn_trash;
            btn_trash.prop({readonly:true, disabled:true});
        }

        const div = make_box(color, { name_input, id }, [
            make_label_cell(name_input),
            make_div_cell([
                $('<p>', {
                    css: { textAlign: 'center' },
                    append: $('<label>', { append: btn_default }),
                }),
                $('<p>', {
                    css: { textAlign: 'center' },
                    append: $('<label>', { append: btn_trash }),
                }),
            ]),
            make_default_bottom(name_input, send, id, color, '', 'die Priorität'),
        ], 'movable');
        div.appendTo(priorities_container);
        priorities_by_id[id] = div;
        btns_by_id[id] = [btn_default, btn_trash];
        return div;
    }

    const list = make_list_fn(get);

    function create (msg) {
        get(msg);
    }

    function isdefault (msg) {
        const { id, count } = msg;
        if (!count || !count[0]) {
            notification.error('Priorität konnte nicht zum Standard gemacht werden.');
            return;
        }

        if (btn_default_set) {
            btn_default_set.prop({readonly:false, disabled:false});
        }
        btn_default_set = (btns_by_id[id] || [])[0];
        if (btn_default_set) {
            btn_default_set.prop({readonly:true, disabled:true});
        }
    }

    function istrash (msg) {
        const { id, count } = msg;
        if (!count || !count[0]) {
            notification.error('Priorität konnte nicht zum Mülleimer gemacht werden.');
            return;
        }

        if (btn_trash_set) {
            btn_trash_set.prop({readonly:false, disabled:false});
        }
        btn_trash_set = (btns_by_id[id] || [])[0];
        if (btn_trash_set) {
            btn_trash_set.prop({readonly:true, disabled:true});
        }
    }

    function error (msg) {
        const { fun, exc } = msg;
        notification.error(`Die Datenbank hat einen unerwarteten Fehler in der Funktion „${fun}“ gemeldet: ${exc}`);
    }

    const color = make_colorfn(notification, priorities_by_id, 'Priorität');

    function remove (msg) {
        const { id, count } = msg;
        const priority = priorities_by_id[id];
        if (count) {
            const [ num_priority ] = count;
            delete priority[id]
            if (priority) {
                priority.hide(function () {
                    priority.remove();
                });
                notification.success('Priorität gelöscht. #Priorität: ' + num_priority);
            }
        } else if (priority) {
            notification.info('Falls noch Umlaufmappen der Priorität zugeordnet sind, kann sie nicht gelöscht werden!');
            notification.error('Priorität konnte nicht gelöscht werden.');
        }
    }

    const send = make_ws(
        url,
        () => { send({ type: 'list' }) },
        { list, get, create, remove, color, isdefault, istrash, error },
    );
}
function zuordnung () {
    const form = $('#form');
    form.on({
        submit (ev) {
            ev.preventDefault();
        },
    });
    const { url } = form.data();

    $(form).on('keypress', 'input[type=text]', ev => {
        const { keyCode, which } = ev;
        const key = (keyCode || which);
        if (key === 10 || key === 13) {
            ev.preventDefault();
        }
    })

    $('<div/>', {
        append: [
            $('<button/>', {
                class: 'k-button',
                text: 'Neue Liste',
                on: {
                    click (ev) {
                        kendo.prompt(
                            'Wie soll die neue Liste heißen?',
                        ).then(name => {
                            name && send({
                                'type': 'new_list',
                                name,
                            });
                        });
                    },
                },
            }),
        ],
        appendTo: form,
    });

    const lists_container = $('<div/>', {
        appendTo: form,
    });
    make_sortable_ranking(lists_container, (ev) => {
        const { oldIndex, newIndex, item } = ev;
        const { id } = item.data();
        send({ type: 'sort_list', id, oldIndex, newIndex });
    });

    enable_notifications(form);

    const lists_by_id = new_object();
    const rows_by_id = new_object();

    const MOVE_TITLE = 'Bitte ziehen Sie die Zahl und lassen Sie sie auf eine andere fallen, um eine Zeile neu zuzuordnen.';

    const IMGS = {
        locked:   'https://bib.vetmed.fu-berlin.de/static/icons/feathericons.com/156c091/external-link.svg',
        rerank1:  'https://bib.vetmed.fu-berlin.de/static/icons/feathericons.com/156c091/shuffle.svg',
        rerank2:  'https://bib.vetmed.fu-berlin.de/static/icons/feathericons.com/156c091/list.svg',
        reparent: 'https://bib.vetmed.fu-berlin.de/static/icons/feathericons.com/156c091/folder.svg',
        remove:   'https://bib.vetmed.fu-berlin.de/static/icons/feathericons.com/156c091/trash-2.svg',
    };

/******************************************************************************
 * HELPER FUNCTIONS
 *****************************************************************************/

    function format_entries (entries, container) {
        if (entries) {
            return entries.map(entry => format_entry(entry, container));
        } else {
            return [];
        }
    }

    function format_entry (entry, container) {
        const { id, parent_id, children, checkboxlist_id } = entry;
        let { name } = entry;

        const old_row = rows_by_id[id];
        delete rows_by_id[id];
        if (old_row) {
            old_row.remove();
        }

        const tangible = { id, parent_id, checkboxlist_id, container };

        const rank_input = tangible.rank_input = $('<a/>', {
            data: { tangible },
            append: $('<img>', {
                src: IMGS.locked,
                alt: '',
                css: { width: '2rem', height: '2rem', padding: '0.25rem', display: 'inline-block', },
            }),
            class: 'locked',
            href: 'javascript:;',
            on: {
                click (ev) {
                    console.log($(ev.currentTarget));
                    if (rank_input.is('.locked')) {
                        open(
                            `./../ablage/#!checkboxentry_id=${id}`,
                            '_blank',
                        );
                    } else if (rank_input.is('.remove')) {
                        if (!children_div.is(':empty')) {
                            notification.warning('Sie müssen zuerst alle Unterpunkte der Zeile entfernen, bevor Sie sie löschen können.')
                        } else {
                            kendo.confirm(
                                `Wollen Sie „${name_input.val()}“ wirklich löschen? Das Löschen kann nicht rückgängig gemacht werden!`,
                            ).then(() => { send({ 'type': 'del_row', id }) });
                        }
                    }
                },
            },
        });

        const handle = tangible.handle = $('<div/>', {
            append: rank_input,
            class: 'rank-input',
            css: {
                display: 'table-cell',
                padding: 0,
                margin: 0,
                verticalAlign: 'middle',
            },
        });

        const name_input = tangible.name_input = $('<input/>', {
            type: 'text',
            val: name,
            class: 'k-input',
            css: {
                width: '100%',
                maxWidth: '100%',
                margin: 0,
            },
        }).on(CHANGE_EVENTS, debounce(ev => {
            const new_name = name_input.val();
            if (new_name && (new_name !== name)) {
                name = new_name;
                send({
                    'type': 'rename_row',
                    name,
                    id,
                });
            }
        }, 360));

        const top = $('<div/>', {
            css: {
                display: 'table-row',
                width: '100%',
                maxWidth: '100%',
                verticalAlign: 'middle',
            },
            append: [
                handle,
                $('<label/>', {
                    append: name_input,
                    css: {
                        display: 'table-cell',
                        padding: '1ex 1ex 1ex 0',
                    },
                }),
            ],
        });

        const empty_div = tangible.empty_div = $('<div/>', { css: { display: 'table-cell' } });
        const children_div = tangible.children_div = $('<div/>', { css: { display: 'table-cell' } });

        const bottom = $('<div/>', {
            css: {
                display: 'table-row',
                width: '100%',
                maxWidth: '100%',
            },
            class: 'children-container',
            append: [ empty_div, children_div ],
        });

        container.data('tangibles')[id] = tangible;

        children_div.append(format_entries(children, container));

        const row = $('<div/>', {
            css: {
                display: 'table',
            },
            data: { id, checkboxlist_id, name_input, children_div, parent_id },
            append: [
                $('<div>', {
                    class: 'not-sort-handler',
                    append: [top, bottom],
                }),
            ],
        });
        rows_by_id[id] = row;

        if (!parent_id) {
            return row;
        }

        setTimeout(function () {
            const parent = rows_by_id[parent_id];
            if (parent) {
                const { children_div: sibling_div } = parent.data();
                sibling_div.append(row);
            }
        }, 0);
    }

/******************************************************************************
 * Function buttons
 *****************************************************************************/

    function destroy (d) {
        d && d.destroy && d.destroy();
    }

    const relock = {
        reparent ({ handle, empty_div, rank_input }) {
            destroy(handle.getKendoDropTarget());
            destroy(empty_div.getKendoDropTarget());
            destroy(rank_input.getKendoDraggable());
        },

        rerank1 ({ empty_div, checkboxlist_id }) {
            const list = lists_by_id[checkboxlist_id];
            const { middle } = list.data();
            destroy(middle.getKendoSortable());

            empty_div.closest('.children-container').css({ display: 'table-row' });
        },

        rerank2 ({ children_div }) {
            destroy(children_div.getKendoSortable());
        },
    };

    function locked (tangibles) {
        forEach(tangibles, tangible => {
            const { rank_input } = tangible;
            (relock[rank_input.attr('class')] || noop)(tangible);
            $('img', rank_input).attr({ src: IMGS.locked });
            rank_input.attr('class', 'locked');
        });
    }

    function make_subsortable (container) {
        return container && container.kendoSortable({
            container,
            filter: '>*',
            autoScroll: true,
            hint (elem) {
                const append = elem.clone();
                $('.children-container', append).remove();
                return $('<div>', {
                    class: 'umlaufverwaltung-content',
                    append,
                });
            },
            change ({ oldIndex, newIndex, item }) {
                const { id, checkboxlist_id, parent_id } = item.data();
                send({
                    type: 'sort_entry',
                    id, checkboxlist_id, parent_id,
                    oldIndex, newIndex,
                });
            },
        });
    }

    function rerank1 (tangibles) {
        forEach(tangibles, ({ empty_div, rank_input, parent_id }) => {
            if (!parent_id) {
                empty_div.closest('.children-container').css({ display: 'none' });
                $('img', rank_input).attr({ src: IMGS.rerank1 });
                rank_input.attr('class', 'rerank1');
            }
        });

        forEach(
            keyBy(tangibles, 'checkboxlist_id'),
            ({ checkboxlist_id }) => {
                const list = lists_by_id[checkboxlist_id];
                const { middle } = list.data();
                make_subsortable(middle);
            },
        );
    }

    function rerank2 (tangibles) {
        forEach(
            tangibles,
            ({ children_div, parent_id, rank_input }) => {
                if (!parent_id) {
                    make_subsortable(children_div);
                    rank_input.attr('class', 'rerank2');
                } else {
                    $('img', rank_input).attr({ src: IMGS.rerank1 });
                    rank_input.attr('class', 'rerank3');
                }
            },
        );
    }

    function reparent (tangibles) {
        forEach(tangibles, ({ handle, empty_div, rank_input, container }) => {
            function may_drop_handle ({ draggable: { element }, dropTarget }) {
                const src_data = element.data().tangible;
                const { id: src_id, parent_id: old_parent, checkboxentry_id: old_list } = src_data;
                const { id: dst_id, parent_id: dst_parent, checkboxentry_id: new_list } = $('>a', dropTarget).data().tangible;
                return (
                    (src_id !== dst_id) &&      // don't drop on yourself
                    (old_list === new_list) &&  // keep same list
                    (old_parent !== dst_id) &&  // don't drop on current parent
                    !dst_parent &&              // target is not a child
                    [src_id, dst_id, src_data]
                );
            }

            function may_drop_empty ({ draggable: { hint }, dropTarget }) {
                const src_data = dropTarget.closest('.not-sort-handler').parent().data();
                const { id: dest_id } = src_data;
                const { id: source_id, parent_id: old_parent } = hint.data();

                if (old_parent !== dest_id) {
                    console.log({old_parent, dest_id});
                    // void
                } else {
                    return [source_id, dest_id, src_data];
                }
            }

            handle.kendoDropTarget({
                dragenter (ev) {
                    if (may_drop_handle(ev)) {
                        handle.css({ backgroundColor: 'lightgreen' });
                    }
                },
                dragleave (ev) {
                    handle.css({ backgroundColor: 'unset' });
                },
                drop (ev) {
                    handle.css({ backgroundColor: 'unset' });
                    const result = may_drop_handle(ev);
                    if (result) {
                        const [id, parent_id, src_data] = result;
                        src_data.parent_id = parent_id;
                        send({ 'type': 'move_row', id, parent_id });
                    }
                },
            });

            empty_div.kendoDropTarget({
                dragenter (ev) {
                    if (may_drop_empty(ev)) {
                        empty_div.css({ backgroundColor: 'lightgreen' });
                    }
                },
                dragleave (ev) {
                    empty_div.css({ backgroundColor: 'unset' });
                },
                drop (ev) {
                    empty_div.css({ backgroundColor: 'unset' });
                    const result = may_drop_empty(ev);
                    if (result) {
                        const [id, dest_id, src_data] = result;
                        src_data.parent_id = 0;
                        send({
                            'type': 'move_row',
                            id,
                            parent_id: 0,
                        });
                    }
                },
            });

            rank_input.kendoDraggable({
                container,
                axis: 'y',
                cursorOffset: {
                    top: 15,
                    left: 15,
                },
                dragstart (ev) {
                    const { currentTarget } = ev;
                    const { children_div } = $(currentTarget).data('tangible');
                    if ($('div', children_div).length > 0) {
                        ev.preventDefault();
                        notification.warning('Sie können keine Zeile verschieben, wenn sie Kinder hat.');
                    }
                },
                hint (element) {
                    const { id, parent_id, checkboxlist_id, name_input } = element.data('tangible');
                    const list = lists_by_id[checkboxlist_id];
                    return $('<div>', {
                        text: name_input.val(),
                        css: {
                            padding: '1ex',
                            border: '0.3ex solid',
                            borderColor: (list ? list[0].style.borderColor : '#ffffff'),
                            borderRadius: '1ex',
                            boxShadow: '0 0 0.3ex black',
                            background: 'rgba(255, 255, 255, 0.4)',
                            pointerEvents: 'none',
                        },
                        data: { id, parent_id },
                    });
                },
            });

            $('img', rank_input).attr({ src: IMGS.reparent });
            rank_input.attr('class', 'reparent');
        });
    }

    function remove (tangibles) {
        forEach(tangibles, ({ rank_input }) => {
            $('img', rank_input).attr({ src: IMGS.remove });
            rank_input.attr('class', 'remove');
        });
    }

    const list_functions = { rerank1, rerank2, reparent, remove };

/******************************************************************************
 * CALLBACKS
 *****************************************************************************/

    function get (msg) {
        const { data } = msg;
        const { id, rank, color, active, entries } = data;
        let { name } = data;
        sort_by_rank(entries);

        const name_input = make_name_input(name, make_sendfn(send, id, 'rename_list', 'name'));

        const add_row_btn = $('<button/>', {
            class: 'k-button',
            type: 'button',
            text: '+Zeile',
            css: {
                padding: '0.3ex',
                marginTop: '2px',
            },
            on: {
                click (ev) {
                    ev.preventDefault();
                    kendo.prompt(
                        'Wie soll die neue Zeile lauten? Der Name muss einmalig in der Liste sein.',
                    ).then(name => {
                        name && send({
                            'type': 'new_row',
                            id,
                            name,
                        });
                    });
                },
            },
        });

        const ranks_inputs = new_object();
        const sort_handles = new_object();
        const tangibles = new_object();

        const middle = make_div_cell([]);
        middle.data('tangibles', tangibles);
        middle.append(format_entries(entries, middle));

        const functions_container = make_div_cell([
            $('<a/>', {
                append: $('<img>', {
                    src: IMGS.locked,
                    alt: '',
                    css: { width: '2rem', height: '2rem', margin: '0 0.33rem', display: 'inline-block' },
                }),
                href: 'javascript:;',
                title: 'Funktion: Auf Pinnwand anzeigen',
                class: 'locked',
            }),
            $('<a/>', {
                append: $('<img>', {
                    src: IMGS.rerank1,
                    alt: '',
                    css: { width: '2rem', height: '2rem', margin: '0 0.33rem', display: 'inline-block' },
                }),
                href: 'javascript:;',
                title: 'Funktion: Sortierung bearbeiten (außen)',
                class: 'rerank1',
            }),
            $('<a/>', {
                append: $('<img>', {
                    src: IMGS.rerank2,
                    alt: '',
                    css: { width: '2rem', height: '2rem', margin: '0 0.33rem', display: 'inline-block' },
                }),
                href: 'javascript:;',
                title: 'Funktion: Sortierung bearbeiten (innen)',
                class: 'rerank2',
            }),
            $('<a/>', {
                append: $('<img>', {
                    src: IMGS.reparent,
                    alt: '',
                    css: { width: '2rem', height: '2rem', margin: '0 0.33rem', display: 'inline-block' },
                }),
                href: 'javascript:;',
                title: 'Funktion: Einordnung bearbeiten',
                class: 'reparent',
            }),
            $('<a/>', {
                append: $('<img>', {
                    src: IMGS.remove,
                    alt: '',
                    css: { width: '2rem', height: '2rem', margin: '0 0.33rem', display: 'inline-block' },
                }),
                href: 'javascript:;',
                title: 'Funktion: Löschen',
                class: 'remove',
            }),
        ]).css({ textAlign: 'center' }).on('click', 'a', function (ev) {
            ev.preventDefault();
            const { currentTarget } = ev;
            const { className } = currentTarget;
            const { tangibles } = $(currentTarget).closest('.outer').parent().data();

            locked(tangibles);
            (list_functions[className] || noop)(tangibles);
        });

        const div = make_box(color, { name_input, middle, id, tangibles }, [
            make_label_cell(name_input),
            functions_container,
            middle,
            make_label_cell(add_row_btn).css({textAlign: 'center'}),
            make_bottom_cell([
                make_color_picker_btn(color, make_sendfn(send, id, 'list_color', 'value')),
                make_delete_btn('die Liste', name_input, make_sendfn(send, id, 'del_list')),
            ]),
        ], 'movable');
        div.appendTo(lists_container);
        lists_by_id[id] = div;
    }

    const list = make_list_fn(get);

    const new_list = get;

    function del_list (msg) {
        const { id, count } = msg;
        const [ num_tags, num_rows, num_lists ] = count;

        const list = lists_by_id[id];
        delete lists_by_id[id];
        if (list) {
            const { name_input } = list.data()
            list.hide(function () {
                list.remove();
            });
            notification.success((
                'Liste gelöscht: „' + name_input.val() + '“' +
                '. #Listen: ' + num_lists +
                '. #Zeilen: ' + num_rows +
                '. #Markierungen: ' + num_tags
            ));
        }
    }

    function del_row (msg) {
        const { id, count } = msg;
        const [ num_tags, num_rows ] = count;

        const row = rows_by_id[id];
        delete rows_by_id[id]
        if (row) {
            const { checkboxlist_id } = row.data();
            const { tangibles } = lists_by_id[checkboxlist_id].data() || {};
            if (tangibles) {
                delete tangibles[id];
            }

            row.hide(function () {
                row.remove();
            });
            notification.success((
                'Zeile gelöscht' +
                '. #Zeilen: ' + num_rows +
                '. #Markierungen: ' + num_tags
            ));
        }
    }

    const list_color = make_colorfn(notification, lists_by_id, 'Liste', 'value');

    function new_row (msg) {
        const { data } = msg;
        const { checkboxlist_id } = data;
        const list = lists_by_id[checkboxlist_id];
        if (list) {
            const { middle } = list.data();
            middle.append(format_entry(data, middle));
        }
    }

    function move_row (msg) {
        new_row(msg);
        const { data: { id, checkboxlist_id } } = msg;
        const { tangibles } = lists_by_id[checkboxlist_id].data();
        reparent([ tangibles[id] ]);
    }

    function rename_row (msg) {
        const { id, name, count } = msg;
        const [ row_count ] = count;
        if (!name) {
            notification.warning('Die Zeile wurde nicht gefunden. Wurde sie zwischenzeitlich gelöscht?');
        } else if (row_count) {
            notification.info(`Zeile wurde umbenannt: „${name}“`);
        } else {
            notification.warning('Zeile wurde nicht umbenannt. Namen müssen in einer Liste eindeutig sein. Ist der Name eindeutig?');
        }
    }

    function rename_list (msg) {
        const { id, name, count } = msg;
        const [ row_count ] = count;
        if (!name) {
            notification.warning('Die Liste wurde nicht gefunden. Wurde sie zwischenzeitlich gelöscht?');
        } else if (row_count) {
            notification.info(`Liste wurde umbenannt: „${name}“`);
        } else {
            notification.warning('Liste wurde nicht umbenannt. Namen müssen eindeutig sein. Ist der Name eindeutig?');
        }
    }

    function sort_entry (msg) {
        notification.success('Sortierung aktualisiert.');
    }

    const send = make_ws(
        url,
        () => { send({ type: 'list_lists' }) },
        { list, new_list, del_list, new_row, del_row, list_color, move_row, rename_row, rename_list, get, sort_entry },
    );
}
setTimeout(function () {
    ({
        ablage_get,
        ablage_kalender,
        ablage_list,
        ablage_tabelle,
        defaulttextblock_list,
        login,
        priority_list,
        zuordnung,
    }[$('body').data('page')] || noop)();
}, 0);

